import React from 'react';

/**
 * Renders a team logo: uploaded image if present, otherwise emoji/initial on colored background.
 * @param {object} team - Team object with logoImage?, logoColor?, logoEmoji?, name?
 * @param {number} size - Width/height in pixels (default 40)
 * @param {object} style - Optional extra styles for the container
 */
function TeamLogo({ team, size = 40, style = {} }) {
  const s = Number(size) || 40;
  const containerStyle = {
    width: s,
    height: s,
    borderRadius: '10%',
    backgroundColor: team?.logoColor || 'var(--primary)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    flexShrink: 0,
    ...style,
  };

  if (team?.logoImage) {
    return (
      <div style={containerStyle}>
        <img
          src={team.logoImage}
          alt=""
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      </div>
    );
  }

  const initial = team?.logoEmoji || team?.name?.charAt(0)?.toUpperCase() || '?';

  return (
    <div style={containerStyle}>
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          transform: 'scale(0.8)',
          fontSize: Math.max(10, Math.floor(s * 0.5)),
          fontWeight: 'bold',
          color: 'var(--card)',
        }}
      >
        {initial}
      </span>
    </div>
  );
}

export default TeamLogo;
